import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateExtensionProfileQueryVariables = Types.Exact<{
  extensionId: Types.Scalars['Int']['input'];
}>;


export type UpdateExtensionProfileQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', homeNumber: string, mobileNumber: string, secretaryNumberId?: number | null, featuresRestrictions: Array<Types.FeatureRestriction | null>, number?: { __typename?: 'Number', domain: { __typename?: 'Domain', domainType: Types.DomainType } } | null } | null> } | null, userProfiles?: Array<{ __typename?: 'UserProfile', active: boolean, anonymousCallRejection: boolean, callForwardBusy: boolean, callForwardBusyNumber: string, callForwardBusySavedNumber: string, callForwardFault: boolean, callForwardFaultNumber: string, callForwardFaultSavedNumber: string, callForwardNoanswer: boolean, callForwardNoanswerNumber: string, callForwardNoanswerSavedNumber: string, callForwardNoanswerTimeout: number, callForwardUnavailable: boolean, callForwardUnavailableNumber: string, callForwardUnavailableSavedNumber: string, callForwardUnconditional: boolean, callForwardUnconditionalNumber: string, callForwardUnconditionalSavedNumber: string, callingNamePresentation: boolean, callingNumberPresentationRestriction: boolean, connectedNumberPresentationRestriction: boolean, doNotDisturb: boolean, id: number, locked?: boolean | null, name: string, parallelRinging: boolean, parallelRingingNumber: string, parallelRingingSavedNumber: string, rejectDivertedCalls: boolean, secretaryMode: Types.SecretaryMode, stickyProfile: boolean, rules: Array<{ __typename?: 'UserProfileRule', id: number, priority: number, sourceNumber: string, action: Types.ExtensionProfileRuleAction, targetNumber: string, matchType?: Types.UserProfileRuleMatchType | null }>, activationTimes: Array<{ __typename?: 'UserProfileActivationTime', weekday: Types.Weekday, activationTime: string, id: number, profileId: number }>, specialDays: Array<{ __typename?: 'UserProfileSpecialDay', id: number, day: string, everyYear: boolean, activationTime?: string | null }> } | null> | null };

export type ActivateExtensionProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type ActivateExtensionProfileMutation = { __typename?: 'Mutation', activateUserProfile?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', type: string }> | null } | null };

export type ExtensionProfileMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  data: Types.UpdateUserProfileData;
}>;


export type ExtensionProfileMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };


export const UpdateExtensionProfileDocument = gql`
    query UpdateExtensionProfile($extensionId: Int!) {
  users(id: $extensionId) {
    items {
      homeNumber
      mobileNumber
      secretaryNumberId
      featuresRestrictions
      number {
        domain {
          domainType
        }
      }
    }
  }
  userProfiles(extensionId: $extensionId) {
    active
    anonymousCallRejection
    callForwardBusy
    callForwardBusyNumber
    callForwardBusySavedNumber
    callForwardFault
    callForwardFaultNumber
    callForwardFaultSavedNumber
    callForwardNoanswer
    callForwardNoanswerNumber
    callForwardNoanswerSavedNumber
    callForwardNoanswerTimeout
    callForwardUnavailable
    callForwardUnavailableNumber
    callForwardUnavailableSavedNumber
    callForwardUnconditional
    callForwardUnconditionalNumber
    callForwardUnconditionalSavedNumber
    callingNamePresentation
    callingNumberPresentationRestriction
    connectedNumberPresentationRestriction
    doNotDisturb
    id
    locked
    name
    parallelRinging
    parallelRingingNumber
    parallelRingingSavedNumber
    rejectDivertedCalls
    secretaryMode
    stickyProfile
    rules {
      id
      priority
      sourceNumber
      action
      targetNumber
      matchType
    }
    activationTimes {
      weekday
      activationTime
      id
      profileId
    }
    specialDays {
      id
      day
      everyYear
      activationTime
    }
  }
}
    `;

/**
 * __useUpdateExtensionProfileQuery__
 *
 * To run a query within a React component, call `useUpdateExtensionProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtensionProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateExtensionProfileQuery({
 *   variables: {
 *      extensionId: // value for 'extensionId'
 *   },
 * });
 */
export function useUpdateExtensionProfileQuery(baseOptions: Apollo.QueryHookOptions<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables> & ({ variables: UpdateExtensionProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>(UpdateExtensionProfileDocument, options);
      }
export function useUpdateExtensionProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>(UpdateExtensionProfileDocument, options);
        }
export function useUpdateExtensionProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>(UpdateExtensionProfileDocument, options);
        }
export type UpdateExtensionProfileQueryHookResult = ReturnType<typeof useUpdateExtensionProfileQuery>;
export type UpdateExtensionProfileLazyQueryHookResult = ReturnType<typeof useUpdateExtensionProfileLazyQuery>;
export type UpdateExtensionProfileSuspenseQueryHookResult = ReturnType<typeof useUpdateExtensionProfileSuspenseQuery>;
export type UpdateExtensionProfileQueryResult = Apollo.QueryResult<UpdateExtensionProfileQuery, UpdateExtensionProfileQueryVariables>;
export const ActivateExtensionProfileDocument = gql`
    mutation ActivateExtensionProfile($id: Int!) {
  activateUserProfile(id: $id) {
    errors {
      type
    }
  }
}
    `;
export type ActivateExtensionProfileMutationFn = Apollo.MutationFunction<ActivateExtensionProfileMutation, ActivateExtensionProfileMutationVariables>;

/**
 * __useActivateExtensionProfileMutation__
 *
 * To run a mutation, you first call `useActivateExtensionProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateExtensionProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateExtensionProfileMutation, { data, loading, error }] = useActivateExtensionProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateExtensionProfileMutation(baseOptions?: Apollo.MutationHookOptions<ActivateExtensionProfileMutation, ActivateExtensionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateExtensionProfileMutation, ActivateExtensionProfileMutationVariables>(ActivateExtensionProfileDocument, options);
      }
export type ActivateExtensionProfileMutationHookResult = ReturnType<typeof useActivateExtensionProfileMutation>;
export type ActivateExtensionProfileMutationResult = Apollo.MutationResult<ActivateExtensionProfileMutation>;
export type ActivateExtensionProfileMutationOptions = Apollo.BaseMutationOptions<ActivateExtensionProfileMutation, ActivateExtensionProfileMutationVariables>;
export const ExtensionProfileDocument = gql`
    mutation ExtensionProfile($id: Int!, $data: UpdateUserProfileData!) {
  updateUserProfile(id: $id, data: $data) {
    errors {
      location
      context
      type
    }
  }
}
    `;
export type ExtensionProfileMutationFn = Apollo.MutationFunction<ExtensionProfileMutation, ExtensionProfileMutationVariables>;

/**
 * __useExtensionProfileMutation__
 *
 * To run a mutation, you first call `useExtensionProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtensionProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extensionProfileMutation, { data, loading, error }] = useExtensionProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExtensionProfileMutation(baseOptions?: Apollo.MutationHookOptions<ExtensionProfileMutation, ExtensionProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtensionProfileMutation, ExtensionProfileMutationVariables>(ExtensionProfileDocument, options);
      }
export type ExtensionProfileMutationHookResult = ReturnType<typeof useExtensionProfileMutation>;
export type ExtensionProfileMutationResult = Apollo.MutationResult<ExtensionProfileMutation>;
export type ExtensionProfileMutationOptions = Apollo.BaseMutationOptions<ExtensionProfileMutation, ExtensionProfileMutationVariables>;